// extracted by mini-css-extract-plugin
module.exports = {"left":"doctorHome_left__3vVU6","left_tag":"doctorHome_left_tag__3GbgE","left_desc":"doctorHome_left_desc__4bIwW"};